import { useState } from "react";
import { Box, CssBaseline, Toolbar } from "@mui/material";

import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppShell({ children }) {

    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (

        <Box sx={{ display: "flex" }}>

            <CssBaseline />

            <Topbar
                handleDrawerToggle={handleDrawerToggle}
            />

            <Sidebar
                mobileOpen={mobileOpen}
                handleDrawerToggle={handleDrawerToggle}
            />

            <Box

                component="main"

                sx={{

                    flexGrow: 1,

                    p: 3,

                    width: {
                        md: `calc(100% - 250px)`
                    },

                    minHeight: "100vh",

                    backgroundColor: "#F5F7FA"

                }}

            >

                {/* Space below AppBar */}

                <Toolbar />

                {children}

            </Box>

        </Box>

    );

}